import Service from "../../service";

const auth = {

    // auth
    onLogIn(data) {
        return Service.post(`/login`,data);
    },
    onLogOut(data) {
      return Service.get(`/logout`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getUserDetail(data) {
        return Service.get(`/details`, { headers: { Authorization: `Bearer ${data.token}` } });
    },
    // User manager
    getAllAccountPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/user?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getAccount(data) {
        return Service.get(`/user/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createAccount(data) {
        return Service.post(`/user`,{
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            username: data.username,
            password: data.password,
            c_password: data.c_password
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editAccount(data) {
        return Service.put(`/user/${data.id}`, {
            first_name: data.first_name,
            last_name: data.last_name,
            // email: data.email,
            username: data.username,
            password: data.password,
            c_password: data.c_password
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteAccount(data) {
        return Service.delete(`/user/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    }

};

export default auth;
